/**
 * Onboarding API (F-031).
 * Endpoints for tenant onboarding configuration and project readiness status.
 */
import axios from "axios";
import { API } from "./client";

// ── Tenant Configuration ─────────────────────────────────────────────────────

export async function getOnboardingConfig() {
  const res = await axios.get(`${API}/settings/onboarding-config`);
  return res.data;
}

export async function updateOnboardingConfig(config) {
  const res = await axios.put(`${API}/settings/onboarding-config`, config);
  return res.data;
}

export async function getOnboardingPresets() {
  const res = await axios.get(`${API}/settings/onboarding-presets`);
  return res.data;
}

export async function createOnboardingPreset(preset) {
  const res = await axios.post(`${API}/settings/onboarding-presets`, preset);
  return res.data;
}

// ── Project Onboarding Status ────────────────────────────────────────────────

export async function getProjectOnboardingStatus(projectId) {
  const res = await axios.get(`${API}/projects/${projectId}/onboarding-status`);
  return res.data;
}

export async function refreshProjectOnboarding(projectId) {
  const res = await axios.post(`${API}/projects/${projectId}/onboarding/refresh`);
  return res.data;
}

export async function aiInferDocuments(projectId) {
  const res = await axios.post(`${API}/projects/${projectId}/onboarding/ai-infer`);
  return res.data;
}
